export default __webpack_public_path__ + "static/ceinture5.mobile.inspirations-8deb463049ad96983aa7f7406d1e2f72.jpg";